module.exports = __webpack_public_path__ + "img/Vue-TodoApp-desktop.901a0d5f.png";